<template>
  <div class="tops">
    <!-- <img src="../assets/callbg.png" alt=""> -->
    <h2>关于我们</h2>
  </div>
  <div class="centers">
    <div class="box1s">
      <h3>我们的使命和愿景</h3>
      <p><span>“</span> 结合科学技术提供创新的解决方案，改变我们管理和防控农业和家庭害虫的方式。 我们的目标是创造能够改善人类健康和保护环境的新技术、新产品</p>
    </div>
    <div class="boxs3"> </div>
    <div class="box2s">
      <h3>核心价值</h3>
      <ul>
        <li>
          <h5>正直</h5>
          <p>做事正直。我们通过正直和诚实行事来建立信任并与客户建立牢固和稳定的关系。</p>
        </li>
        <li>
          <h5>好奇心</h5>
          <p>保持好奇的心态，终身对学习充满热情。 我们相信发展您的个人技能并努力不断自我完善。</p>
        </li>
        <li>
          <h5>尊重</h5>
          <p>尊重个人。 我们重视彼此的意见、想法和信念。</p>
        </li>
        <li>
          <h5>问责制</h5>
          <p>对你的行为、言语和结果负责,</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
     
        
      }
    },
    methods:{
      
    },
    created(){},
    mounted(){}
 }
</script>

<style scoped>
.tops{
  /* border: 5px solid red; */
  padding: 8rem;
  overflow: hidden;
  position: relative;
  background: #eee;
}
.tops img{
  width: 100%;
}
.tops h2{
  font-size: 2.2rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  letter-spacing:0.5rem;
  text-indent: 0.5rem;
}
.box1s{
  width: 90%;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.box1s h3{
  font-size:1.8rem;
  margin-bottom: 2rem;
}
.box1s p{
  font-size: 1.3rem;
  width: 70%;
  text-align: center;
  margin: auto;
  line-height: 1.6;
  position: relative;
}
.box1s p span{
  color: #2180D1;
  font-size: 5rem;
  line-height: 1;
  position: absolute;
  left: -10%;
  top: -15%;
}
.box2s{
  /* border: 1px solid red; */
  text-align: center;
}
.box2s ul{
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 70%;
  margin: auto;
  }
  .box2s ul li{
    /* background: pink; */
    width: 35%;
    margin: 1rem;
    color: #3b3c3c;
    padding: 1rem;
    text-shadow:0px 0px 15px #F1F9F9;
  }
  .box2s ul li h5{
    font-size: 1.2rem;
    margin-bottom: 1rem;

  }
  .box2s ul li p{
    font-size: 0.8rem;
    line-height: 1.4;
  }
  .boxs3{
    width: 80%;
    height: 40vh;
    background: #eee;
    margin: auto;
    margin-bottom: 3rem;
  }
</style>